import React, { useEffect, useState, useRef, useContext } from "react";
import { IoClose } from "react-icons/io5";
import { ProjectContext } from "../../ProjectContext";
import { useNavigate } from "react-router-dom";
import { useConnectModal } from "@rainbow-me/rainbowkit";
import axios from "axios";

const CreateNYOModal = () => {
  const {
    copyaddress,
    account,
    toastSuccess,
    toastError,
    settings,
    ethers,
    getsmcs,
    Maincontract,
    Usdtcontract,
    dnetcontract,
    Ubalance,
    Dbalance,
    formatAddress,
    CheckReffaral,
    Refaddress, dbuserx1, dbReward,
  } = useContext(ProjectContext);

  console.log("Refaddress", Refaddress);


  const [selectedCrypto, setSelectedCrypto] = useState(1); // Default to USDT (1)
  const [amount, setAmount] = useState(0);
  const [USDT, setUSDT] = useState(0);
  const [trdone, setTrdone] = useState(false);
  const [hash, setHash] = useState("");
  const [dnet, setdnet] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isDivisibleBy10, setIsDivisibleBy10] = useState(null);
  const { openConnectModal } = useConnectModal();
  const navigate = useNavigate();

  const normalizedValue = dbuserx1 === 0 ? 0 : (dbReward / dbuserx1) * 100;

  console.log("normalizedValue", normalizedValue, dbuserx1, dbReward);


  const [isOpen, setIsOpen] = useState(false);
  const modalRef = useRef(null);

  const toggleHeader = () => {
    setIsOpen(!isOpen);
  };


  const onDeposit = async () => {
    setTrdone(true);
    setHash("");
    setLoading(true);

    // Await the CheckReffaral() function and handle the result
    const referralCheck = await CheckReffaral();

    // If CheckReffaral() returns an error, stop the deposit process
    if (referralCheck.code === 400) {
      setTrdone(false);
      setLoading(false);
      return; // Stop execution if referral is not active
    }

    if (!account) {
      openConnectModal();
      toastError("Connect first");
      setTrdone(false);
      setLoading(false);
      return;
    }

    if (amount < 20 || amount > 10000) {
      toastError("Amount must be between $20 to $10000!");
      setTrdone(false);
      setLoading(false);
      return;
    }

    let allowance;
    if (selectedCrypto === 1) {
      // Check allowance for USDT only
      allowance = await Usdtcontract.allowance(account, settings.contract);
    } else {
      // Check allowance for both USDT and DNET
      allowance = await Usdtcontract.allowance(account, settings.contract);
      allowance = await dnetcontract.allowance(account, settings.contract);
    }

    const requiredAllowance = selectedCrypto === 1
      ? ethers.utils.parseUnits(amount.toString(), 6).toString()
      : ethers.utils.parseUnits(dnet.toString(), 6).toString();

    if (Number(ethers.utils.formatUnits(allowance, 6)) < Number(requiredAllowance)) {
      try {
        if (selectedCrypto === 1) {
          // Approve USDT if allowance is insufficient
          const approv = await Usdtcontract.approve(settings.contract, requiredAllowance);
          await approv.wait();
          toastSuccess("USDT Token Approved");
        } else {
          // Approve USDT if allowance is insufficient
          const approv = await Usdtcontract.approve(settings.contract, requiredAllowance);
          await approv.wait();
          toastSuccess("USDT Token Approved");

          // Approve DNET if allowance is insufficient
          const approvDNET = await dnetcontract.approve(settings.contract, requiredAllowance);
          await approvDNET.wait();
          toastSuccess("DNET Token Approved");
        }
        main(Maincontract);  // Proceed to staking
      } catch (error) {
        console.error("Error during approval:", error);
        toastError("Token approval failed");
        setTrdone(false);
        setLoading(false);
      }
    } else {
    main(Maincontract);  // If allowance is sufficient, proceed with staking
    }
  };


  const main = async (Maincontract) => {
    try {
      const stk = await Maincontract.stake(Refaddress, ethers.utils.parseUnits(amount.toString(), 6).toString(), selectedCrypto);
      const receipt = await stk.wait();
      setHash(receipt.transactionHash);
      toastSuccess("Transaction complete");
      localStorage.clear();
      getsmcs();
      setAmount(0);  // Clear the amount after transaction
    } catch (error) {
      setHash("error");
      console.error("Error during staking:", error);
      toastError(`Transaction failed: ${error.message}`);
    } finally {
      setTrdone(false);
      setLoading(false);
    }
  };

  const handleChange = (event) => {
    const value = event.target.value;
    setAmount(value);

    // Check if the entered value is divisible by 10
    if (value !== '' && !isNaN(value)) {
      setIsDivisibleBy10(Number(value) % 10 === 0);
    } else {
      setIsDivisibleBy10(null);  // Reset if the input is empty or not a number
    }
  };

  useEffect(() => {
    if (amount) {
      fetchData();  // Recalculate when amount changes
    } else {
      setdnet(0);  // Reset if amount is empty
    }
  }, [amount]);

  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        // Programmatically simulate a click on the close button to dismiss the modal
        setIsOpen(false);
        setHash("")
      }, 1000); // Close the modal after 1 second
    }
  }, [hash]);

  const fetchData = async () => {
    try {
      var amt50 = amount / 2;
      setUSDT(amt50);
      const tmt = await Maincontract.calculatetoken(ethers.utils.parseUnits(amt50.toString(), 6).toString());
      setdnet(ethers.utils.formatUnits(tmt.toString(), 6));  // Update the dnet state with calculated value
    } catch (error) {
      console.error("Error calculating token values:", error);
      toastError("Error calculating token values");
    }
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <>
      {/* Button to trigger modal */}
      <button className="button-1 px-5 my-2 mx-2 my-lg-0 w-100" onClick={toggleHeader}>
        <div className="dots_border" />
        <img
          src="../assets/images/lock-icon.png"
          className="sparkle img-fluid"
          alt="lock-icon"
        />

        {normalizedValue >= 100 ?
          <span className="text_button blink_me text-danger">Re-create NYO</span> :
          <span className="text_button">Create NYO</span>}
      </button>

      {/* Modal */}
      {isOpen && (
        <div
          className="modal fade show d-block"
          id="exampleModalCente2"
          style={{ background: "rgb(0 0 0 / 93%)" }}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            role="document"
            ref={modalRef}
          >
            <div className="modal-content new-box">
              <div className="modal-header">
                <h5 className="modal-title text-white">Create NYO</h5>
                <a onClick={toggleHeader} className="c-pointer">
                  <IoClose size={30} />
                </a>
              </div>
              <div className="modal-body">
                {hash ? (
                  <div className="d-flex justify-content-center">
                    <img src="./../assets/img/tr_done.gif" width={150} />
                  </div>
                ) : (
                  <div className="text-center">
                    <div className="mb-3">
                      <div className="d-flex  flex-wrap crypto">
                        {/* {["USDT", "Both ( USDT+ DNET )"].map((crypto, index) => (
                          <div key={index} className="form-check custom-checkbox mr-5 me-5 mb-2 ">
                            <input
                              type="radio"
                              className="form-check-input custom-radio"
                              style={{ height: "20px", width: "20px" }}
                              id={`customRadio${index}`}
                              name="crypto"
                              value={crypto}
                              checked={selectedCrypto === (crypto === "USDT" ? 1 : 2)}
                              onChange={() => {
                                const value = crypto === "USDT" ? 1 : 2;
                                setSelectedCrypto(value);
                              }}
                            />&nbsp;
                            <label className="form-check-label" htmlFor={`customRadio${index}`}>
                              <span className="d-block text-white font-w500">{crypto}</span>
                            </label>
                          </div>
                        ))} */}
                        {["USDT", "Both ( USDT+ DNET )"].map((crypto, index) => (
                          <div key={index} className="form-check custom-checkbox mr-5 me-5 mb-2 ">
                            <input
                              type="radio"
                              className="form-check-input custom-radio"
                              style={{ height: "20px", width: "20px" }}
                              id={`customRadio${index}`}
                              name="crypto"
                              value={crypto}
                              checked={selectedCrypto === (crypto === "USDT" ? 1 : 2)}
                              onChange={() => {
                                const value = crypto === "USDT" ? 1 : 2;
                                setSelectedCrypto(value);
                              }}
                            />&nbsp;
                            <label className="form-check-label" htmlFor={`customRadio${index}`}>
                              <span className="d-block text-white font-w500">{crypto}</span>
                            </label>
                          </div>
                        ))}

                        {/* <div className="form-check custom-checkbox mr-5 mb-2">
                          <input
                            className="form-check-input custom-radio"
                            style={{ height: "20px", width: "20px" }}
                            id="customRadio0"
                            type="radio"
                            defaultValue="Bitcoin"
                            name="crypto"
                          />
                          &nbsp;
                          <label
                            className="form-check-label"
                            htmlFor="customRadio0"
                          >
                            <span className="d-block font-w500">USDT</span>
                          </label>
                        </div>
                        <div className="form-check custom-checkbox mb-2">
                          <input
                            className="form-check-input custom-radio"
                            style={{ height: "20px", width: "20px" }}
                            id="customRadio1"
                            type="radio"
                            defaultValue="Ripple"
                            name="crypto"
                          />{" "}
                          &nbsp;
                          <label
                            className="form-check-label"
                            htmlFor="customRadio1"
                          >
                            <span className="d-block font-w500">
                              
                            </span>
                          </label>
                        </div> */}
                      </div>
                      <div className="d-flex justify-content-between mt-3">
                        <label className="form-label text-white">Amount</label>
                        <label className="form-label text-white">
                          {selectedCrypto === 1
                            ? `$${Ubalance} USDT`
                            : selectedCrypto === 2
                              ? `${Ubalance} USDT + ${Dbalance} DNET`
                              : 0}
                        </label>
                      </div>{" "}
                      <input
                        type="number"
                        className="form-control mt-2 mb-3 py-4"
                        style={{ borderRadius: "10px", borderColor: "gray" }}
                        value={amount}
                        onChange={handleChange}
                        placeholder="Enter Amount"
                        disabled={loading}  // Disable input while loading
                      />
                      {selectedCrypto === 2 && (
                        <div className="mt-3 text-center">
                          <h4 className="mb-0">{USDT} {process.env.REACT_APP_TICKER}</h4>
                          <h4 className="mb-0">{dnet} {process.env.REACT_APP_TOKEN_TICKER} (${USDT})</h4>
                          <p>You Required {process.env.REACT_APP_TOKEN_TICKER} and {process.env.REACT_APP_TICKER}</p>
                        </div>
                      )}
                      {isDivisibleBy10 === false && (
                        <small className="text-danger">Amount must be divisible by 10.</small>
                      )}
                    </div>
                    <button
                      type="button"
                      className="btn btn-sm text-white bg-new-primary"
                      data-bs-dismiss="modal"
                      onClick={onDeposit}
                      disabled={loading || !isDivisibleBy10}  // Disable button while loading or if not divisible by 10
                    >
                      {loading ? "Processing..." : "Create NYO"}
                    </button>
                  </div>
                )}
                {loading && (
                  <div className="d-flex justify-content-center mt-3">
                    <div className="spinner-border text-primary" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                )}
                {hash && (
                  <div className="mt-3 text-center">
                    <h4>
                      <a
                        href={`${process.env.REACT_APP_EXPLORER}tx/${hash}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {formatAddress(hash)}
                      </a>
                      &nbsp;<i className="fa fa-copy" onClick={() => copyaddress(hash)}></i>
                    </h4>
                    <p>Transaction Hash</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CreateNYOModal;